import React from "react";
import "./PdfContent.scss";
import { useParams } from 'react-router-dom';

const GeneralTermContent = () => {
  let tag = {
    62580:{appName:"62580",companyName:"强生致行互联网科技（上海）有限公司"},
    ddcx:{appName:"叮叮出行",companyName:"重庆庞大叮叮科技有限公司南京分公司"},
    ydyc:{appName:"悦道用车",companyName:"上海美跃信息技术有限公司"},
    qxcx:{appName:"前行出行",companyName:"前行无限(天津)科技有限公司"},
    tgcx:{appName:"同港出行",companyName:"重庆渐臻科技有限公司"},
  }
  const params = useParams();
  const routeTag = params.tag;
  let currentTag = routeTag || "62580";
  let appName = tag[currentTag].appName;
  let companyName = tag[currentTag].companyName;
  
  return (
    <div className="pdf-container">
      <div className="pdf-content">
        <h1 className="title">{appName}平台服务协议</h1>
        
        <p className="pdf-paragraph">
          本《{appName}平台服务协议》（以下简称"服务协议"或"本协议"）由{companyName}（以下简称"公司""我们"或"{appName}平台"）制定并予以公布，用户（以下或称"您"）在使用{appName}平台提供的服务前应仔细阅读本协议，特别是本协议中的特别提示条款。用户注册或继续使用我公司提供的服务（以下简称为"服务"），或者登录{appName}平台，则表示用户已完全同意、理解并接受本协议的相关约定，尤其是特别提示条款中的内容。
        </p>

        <p className="pdf-paragraph">
          用户将自觉遵守所有适用的法律和法规。用户一旦使用{appName}平台，则须秉着诚信、守法的原则遵守以下条款。
        </p>

        <p className="pdf-paragraph">
          若您为无民事行为能力人或限制民事行为能力人（例如未满18周岁的未成年人），您应在您的监护人监护、指导下并获得监护人同意的情况下认真阅读并同意本协议，否则请您立即停止操作。若用户未取得监护人的同意，监护人可以联系{appName}平台客服处理相关账号，{appName}平台有权对相关账号的功能、使用进行限制，包括但不限于浏览、发布信息、互动交流等功能。
        </p>

        <h1 className="pdf-main-title">监护人特别提示：</h1>
        
        <h2 className="pdf-clause-title">
          （1）如您的被监护人使用{appName}平台相关软件或平台内各项服务的，您作为监护人应指导并监督被监护人的注册和使用行为，如您的被监护人申请注册{appName}平台账号，我们将有权认为其已取得您的同意；
        </h2>
        
        <h2 className="pdf-clause-title">
          （2）您的被监护人在使用{appName}平台相关软件或平台内各项服务时可能使用购买产品或服务等功能。您作为监护人，请保管好您的支付设备、支付账户及支付密码等，以避免被监护人在未取得您同意的情况下通过您的{appName}平台账号使用购买等消费功能。
        </h2>
        
        <h2 className="pdf-clause-title">
          （3）如您的被监护人违反法律法规、本协议内容，则您作为监护人应依照法律规定承担因此而可能导致的全部法律责任。
        </h2>

        <p className="pdf-paragraph">
          需要特别说明的是，{appName}平台可能会为您和第三方服务商提供各类信息技术服务及信息展示，协助第三方服务商为您提供服务，但这些服务均由第三方实际提供，您应根据您的自身需要自主选择相应服务提供方及服务产品，与第三方服务商订立服务合同或订单，遵守该合同或订单并承担由此产生的后果与责任。{appName}平台无法对第三方服务商的产品/服务的质量、第三方数据信息的实时性、准确性、可用性等进行任何形式的声明、保证或担保。
        </p>

        <h1 className="pdf-main-title">1. 名词定义</h1>
        
        <h2 className="pdf-clause-title">
          1.1 "{appName}平台"，是指{companyName}创建的用于提供移动出行服务等服务的网站及其客户端（包括但不限于移动客户端、微信小程序等），或称为"平台"。
        </h2>
        
        <h2 className="pdf-clause-title">
          1.2 用户：是指{appName}平台各项服务使用者，包括本协议所称"乘客"。
        </h2>
        
        <h2 className="pdf-clause-title">
          1.3 司机：是指为{appName}平台乘客提供驾驶服务的人员。
        </h2>
        
        <h2 className="pdf-clause-title">
          1.4 乘客：是指通过{appName}平台实际使用移动出行服务的人员或指通过{appName}平台为实际使用移动出行服务人员代下订单的人员/法人/非法人组织。
        </h2>
        
        <h2 className="pdf-clause-title">
          1.5 第三方服务商：通过本平台为用户提供第三方商品或服务的法人或其他组织。
        </h2>
        
        <h2 className="pdf-clause-title">
          1.6 订单：是指{appName}平台上登记的用户用车或使用第三方服务具体信息的电子订单。用户应当按照平台页面的要求提供具体服务需求信息，用户提供的全部需求信息作为一个整体构成一个订单。您可通过本平台查询订单情况。
        </h2>

        <h1 className="pdf-main-title">2. 法律声明</h1>
        
        <p className="pdf-paragraph">
          注册、登录或使用{appName}平台，表明您已阅读、理解并同意接受以下条款的约束，并自觉遵守所有适用的法律和法规。您一旦使用{appName}平台，则须秉着诚信、守法的原则遵守以下条款。
        </p>

        <h1 className="pdf-main-title">3. 一般原则</h1>
        
        <p className="pdf-paragraph">
          《{appName}平台服务协议》由《{appName}平台软件使用条款》以及平台不时指向、公布的各类规则、文件等组成。服务协议适用于所有{appName}平台用户。
        </p>
        
        <p className="pdf-paragraph">
          我们非常重视和保护您的个人信息，为了向您说明我们如何收集、存储、使用、加工、传输、提供、公开、删除您的个人信息，我们特别制定了专门的《{appName}隐私政策》。在您使用{appName}平台前，请您务必进行阅读。
        </p>

        <h1 className="pdf-main-title">4. 争议解决及管辖</h1>
        
        <p className="pdf-paragraph">
          本协议适用中国法律。除另有约定外，关于本协议（含《{appName}平台软件使用条款》以及平台不时指向、公布的各类规则、文件等）的违约、终止、履行、解释或有效性，或者网站、{appName}平台的使用所产生的或与其相关的任何冲突、赔偿或纠纷（统称为"争议"），任何一方均可向本协议签订地有管辖权的法院提起诉讼解决。
        </p>
        
        <p className="pdf-paragraph">
          当您与{appName}平台发生争议时，{appName}平台有权要求您提供具体的住址、居住地、有效联系地址用于接收各类公司或司法机关发送的文件文书作为送达地，您通过{appName}平台已提交的地址也将作为接收各类公司或司法机关发送的文件文书送达地，前述文件文书包括但不限于各类通知、合同、诉讼文书等文件及就本协议发生争议时（包括争议进入仲裁、诉讼程序）的相关文件文书等。如因任何原因导致相关文件文书未被用户或其指定方实际接收，公司不承担任何责任。
        </p>
        
        <p className="pdf-paragraph">
          因业务政策调整，服务协议可能随时被修改。我们会将更新后的服务协议公布在{appName}平台，您应定期访问{appName}平台以了解当前最新的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被{appName}平台某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。
        </p>

        <h1 className="pdf-main-title">5. 联系我们</h1>
        
        <p className="pdf-paragraph">
          如您对本协议有任何疑问，或发现有任何本协议规定的情况，或其他任何您想要了解的事项，均可通过本平台中的个人中心{'->'} 服务中心{'->'} 联系客服，联系本平台客户服务专员进行反馈和建议，本平台将尽快核实并在15个工作日内处理您反馈的问题。
        </p>
        
        <p className="pdf-paragraph">
          本服务协议更新日期：【2024】年【04】月【22】日
        </p>
        <p className="pdf-paragraph">
          本服务协议生效日期：【2024】年【04】月【29】日
        </p>
      </div>
    </div>
  );
};

export default GeneralTermContent;
